"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiCssBaseline = void 0;
var tdcLight = {
    fontFamily: 'TDC',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 100,
    src: "url(//s.c.dk/fonts/TDC_lite.woff2) format('woff2')",
};
var tdcRegular = __assign(__assign({}, tdcLight), { fontWeight: 400, src: "url(//s.c.dk/fonts/TDC_regular.woff2) format('woff2')" });
var tdcBold = __assign(__assign({}, tdcLight), { fontWeight: 700, src: "url(//s.c.dk/fonts/TDC_bold.woff2) format('woff2')" });
// Mukata Mahee fonts based on fontsource
var normalMuktaMahee = [
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 300,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-gurmukhi-300-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-300-normal.woff') format('woff')",
        unicodeRange: 'U+0964-0965, U+0A01-0A75, U+200C-200D, U+20B9, U+25CC, U+262C, U+A830-A839',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 300,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-ext-300-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-300-normal.woff') format('woff')",
        unicodeRange: 'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 300,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-300-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-300-normal.woff') format('woff')",
        unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
];
var boldMuktaMahee = [
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 500,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-gurmukhi-500-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-500-normal.woff') format('woff')",
        unicodeRange: 'U+0964-0965, U+0A01-0A75, U+200C-200D, U+20B9, U+25CC, U+262C, U+A830-A839',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 500,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-ext-500-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-500-normal.woff') format('woff')",
        unicodeRange: 'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 500,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-500-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-500-normal.woff') format('woff')",
        unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
];
var bolderMuktaMahee = [
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 600,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-gurmukhi-600-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-600-normal.woff') format('woff')",
        unicodeRange: 'U+0964-0965, U+0A01-0A75, U+200C-200D, U+20B9, U+25CC, U+262C, U+A830-A839',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 600,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-ext-600-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-600-normal.woff') format('woff')",
        unicodeRange: 'U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF',
    },
    {
        fontFamily: 'Mukta Mahee',
        fontStyle: 'normal',
        fontDisplay: 'swap',
        fontWeight: 600,
        src: "url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-latin-600-normal.woff2') format('woff2'), url('//s.c.dk/fonts/mukta-mahee/mukta-mahee-all-600-normal.woff') format('woff')",
        unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD',
    },
];
exports.MuiCssBaseline = {
    '@global': {
        '@font-face': __spreadArray(__spreadArray(__spreadArray([tdcLight, tdcRegular, tdcBold], normalMuktaMahee, true), boldMuktaMahee, true), bolderMuktaMahee, true),
    },
};
